import React,{useEffect} from 'react';
import back from '../assets/smile.png'
import Card from '../components/card'
import Logo from '../assets/logo.png'
import instaLogo from '../assets/logo-insta.svg'
import faceLogo from '../assets/logo-face.svg'
import enem from '../assets/enem.png'
import ano1 from '../assets/1-ano.png'
import ano2 from '../assets/2-ano.png'
import ano6 from '../assets/6-ano.png'
import ano7 from '../assets/7-ano.png'
import ano8 from '../assets/8-ano.png'
import ano9 from '../assets/9-ano.png'
import conta from '../assets/conta.svg'
import { useSelector,useDispatch } from 'react-redux'
import {actions} from '../store/reducers/userReducer'
import api from '../config/api'

export default function Home({history}) {
  const state = useSelector(state => state.userReducer);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!state.logged) {
      const token = localStorage.getItem('token')
      
      if(token) {
        api.post('/authenticate', '', {
          headers: {
            token: token
          }
        })
        .then((response) => {
          response.data.logged = true
          dispatch(actions.setIfosUser(response.data))
        })
          .catch((error) => {
            if (error.response) {
              if (error.response.data.message === "token invalid") {
              } else if (error.response.data.message === "token not declared") {
              } else if (error.response.data.message === "error in athentication") {
              }
          }
        })
      }
    } 
  }, []) // eslint-disable-line

  return ( 
    <div className="container-fluid p-0 m-0">

      <nav className="navbar navbar-expand-lg navbar-dark bg-edited">

        <a className="navbar-brand" href="./">
          <img src={Logo} width="30" height="30" alt="Logo" />
        </a>

        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav">
            <li className="nav-item active">
              <a className="nav-link" href="/">Início</a>
            </li>
          </ul>
        </div>

        <div>
        <a className="navbar-brand pb-2 socialLogos" href="https://www.facebook.com/profile.php?id=100002358731599" target="_blank" rel="noopener noreferrer">
            <img src={faceLogo} width="20" height="20" alt="faceLogo" />
            </a>
        <a className="navbar-brand pb-2 socialLogos" href="https://www.instagram.com/ousadoresolve/" target="_blank" rel="noopener noreferrer">
            <img src={instaLogo} width="20" height="20" alt="instaLogo" />
        </a>
        </div>

        {!state.logged && (
        <div>  
          <button className="btn btn-outline-light mr-2 my-2 my-sm-0" onClick={()=>(history.push('signUp'))}>Registrar</button>
          <button className="btn btn-outline-light my-2 my-sm-0" onClick={()=>(history.push('login'))}>Login</button>

          <button className="navbar-toggler ml-3" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
        </div>)}

        {state.logged && (
            
            <div className='d-flex flex-column text-center'>
              <a className="navbar-brand socialLogos m-0 p-0" href={"/"}>
                <img src={conta} width="40" height="40" alt="Logo" />
              </a>
              <span className='text-light'>{state.username}</span>
            </div>
         )}

      </nav>
    <div className='bg-edited-light'>
        <img src={back} className='img-fluid' alt="faceLogo"/>
        <h3 className='text-center mt-3 text-responsiveH3'>Sobre</h3>
        <p className='container ml-auto mr-auto mt-2 mb-0 pb-3 text-center about'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas et tellus nec velit tempor porta ornare et ligula. Phasellus orci tellus, auctor in hendrerit eget, dignissim fermentum arcu. Proin et risus risus. In viverra eros ac nisl efficitur ultrices. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas et tellus nec velit tempor porta ornare et ligula. Phasellus orci tellus, auctor in hendrerit eget, dignissim fermentum arcu. Proin et risus risus. In viverra eros ac nisl efficitur ultrices</p>
    </div>

    <div className= 'bg-edited pb-4'>
        <h3 className='text-center pt-3 text-light text-responsiveH3'>Cursos</h3>
        <div className='container bg-edited-light line'>
        </div>
        <h4 className='text-center mt-2 text-light text-responsiveH4'>ENEM</h4>
        <div className='ml-2 mr-2'>
          <Card title = 'ENEM' src = {enem} courseName='enem' color='light'/>
        </div>
    </div>

    <div className= 'bg-edited-light pb-4'>
        <h4 className='text-center pt-3 text-dark text-responsiveH4'>Ensino Médio</h4>
       
        <div className='d-flex justify-content-center'>
        <ul className='p-0 ml-1 mr-1'>
        <Card title = '1° Ano' src = {ano1} courseName='1ano' color='dark'/>
        </ul>
        <ul className='p-0 ml-1 mr-1'>
        <Card title = '2° Ano' src = {ano2} courseName='2ano' color='dark'/>
        </ul>
        </div>
    </div>

    <div className= 'bg-edited pb-4'>
        <h4 className='text-center pt-3 text-white text-responsiveH4'>Ensino Fundamental</h4>
       
        <div className='d-flex justify-content-center'>
        <ul className='p-0 ml-1 mr-1'>
        <li className='list'>
        <Card title = '6° Ano' src = {ano6} courseName='6ano' color='light'/>
        <Card title = '8° Ano' src = {ano8} courseName='8ano' color='light'/>
        </li>
        </ul>
        <ul className='p-0 ml-1 mr-1'>
        <li className='list'>
        <Card title = '7° Ano' src = {ano7} courseName='7ano' color='light'/>
        <Card title = '9° Ano' src = {ano9} courseName='8ano' color='light'/>
        </li>
        </ul>
        </div>
    </div>
    <footer className="container-fluid page-footer bg-edited-light footer py-2">
        <div className="footer-copyright">
        Ousado Resolve © 2020 - Todos os direitos reservados
        </div>

        <div className=" footer-copyright">
        <a href="/"> Direitos autorais </a>
        -
        <a href="/"> Termos de uso </a>
        -
        <a href="/"> Política de privacidade </a>
        </div>
        
      </footer>
    
    </div>
);
}